import { getYoutubeThumbnailSrc } from '@helpers/youtube';
import MediaModal from '@pages/Media/components/MediaModal';
import { IMedia, MediaType } from 'interface/medias';
import { useCallback, useState } from 'react';
import './style.less';

type RPMediaProps = {
  media: IMedia;
};

export const RPMedia: React.FC<RPMediaProps> = ({ media }) => {
  const [open, setOpen] = useState<boolean>(false);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <div className="rp-media-card">
      {media.mediaType === MediaType.IMAGE ? (
        <img src={media.source} alt={media.name} />
      ) : media.mediaType === MediaType.YOUTUBE ? (
        <img
          aria-hidden="true"
          onClick={openModal}
          src={getYoutubeThumbnailSrc(media.source)}
          className="youtube-thumbnail"
          alt="youtube-thumbnail"
        />
      ) : (
        <video onClick={openModal}>
          <source src={media.source} type="video/mp4" />
        </video>
      )}
      <MediaModal media={media} onClose={closeModal} open={open} />
    </div>
  );
};
